import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: '0',
      height: '100%',

      flex: 1,

      '& > div:first-child': {
        height: '100%',
        minHeight: '0',
        overflowY: 'auto',

        '& > div': {
          height: '100%',
          minHeight: '250px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          overflowY: 'auto',

          '& .MuiSvgIcon-root': {
            fontSize: 76,
            color: theme.palette.primary.main,
            marginBottom: '2rem',
          },
          '& .MuiTypography-h1': {
            color: theme.palette.text.primary,
            fontWeight: 500,
            fontSize: '2rem',
            lineHeight: '35px',
          },
          '& .MuiTypography-h2': {
            color: theme.palette.text.primary,
            fontWeight: 500,
            fontSize: '2rem',
            lineHeight: '35px',
          },
        },
      },

      '& > div:last-child': {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-end',
        padding: '2rem 0',

        '& > a > button': {
          width: 'auto',
          height: 'auto',
          margin: '0',
          padding: '1rem 1.5rem',
          minWidth: '10rem',
        },
      },
    },
  }),
)
